export { FormlyFieldCheckbox } from './checkbox';
export { FormlyFieldMultiCheckbox } from './multicheckbox';
export { FormlyFieldInput } from './input';
export { FormlyFieldRadio } from './radio';
export { FormlyFieldTextArea } from './textarea';
export { FormlyFieldSelect } from './select';
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/types/types.js
// module id = 329
// module chunks = 3